import { Button, Card, Form, Input, Space, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { API } from '../../config/api';
import { DELETE, GET, POST } from '../../utils/apicalls';
import LayoutHeader from '../../adminnavigation/layoutHeader';
import { App } from 'antd'; // Import App for notification context
import { useNavigate } from 'react-router-dom';

function IndexCategory() {
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const [CategoryData, setCategoryData] = useState<any>([]);
    const { notification } = App.useApp(); // Use App context hook to access notification
    const navigate = useNavigate();
    const submitHandler = async (values: any) => {
        try {
            let obj = {
                categoryTitle: values.categoryTitle,
                categoryImage: "string",
            };

            setIsLoading(true);
            const postRequest = await POST(API.CREATE_CATEGORY, obj);

            if (postRequest) {
                notification.success({ message: "Category created successfully!" });
                form.resetFields();
                fetachALLCategory()
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const columns = [
        {
            title: "Index",
            dataIndex: "index",
            render: (_: any, __: any, index: number) => index + 1,
        },
        { title: "categoryTitle", dataIndex: "categoryTitle" },


        {
            title: "Actions",
            key: "actions",
            render: (_: any, record: any) => (
                <Space size="middle">
                    <Button type="link" onClick={() => confirmDelete(record.id)}>Delete</Button>
                    <Button
                        type="link"
                        onClick={() =>
                            navigate(
                                `/Admin/adminCategory/updateCategory/${record.id}`
                            )
                        }
                    >
                        Edit
                    </Button>
                </Space>
            ),
        },
    ];
    const fetachALLCategory = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_CATEGORIES, {});
            setCategoryData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetachALLCategory();
    }, []);
    const handleDelete = async (id: any) => {
        try {
            setIsLoading(true);
            const delete_customer_url = `${API.DELETE_CATEGORY}${id}`;
            const data: any = await DELETE(delete_customer_url);

            if (data.status) {
                notification.success({ message: " deleted successfully!" });
                fetachALLCategory();
            } else {
                notification.error({
                    message: "Something went wrong! Please try again later.",
                });
            }
        } catch (error) {
            console.log(error);
            notification.error({
                message: "Something went wrong! Please try again later.",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const confirmDelete = (id: any) => {
        const confirm = window.confirm(
            "Are you sure you want to delete this review?"
        );
        if (confirm) {
            handleDelete(id);
        }
    };

    return (
        <div>
            <LayoutHeader />
            <div>
                <h1 style={{ textAlign: "center", marginTop: "20px" }}>Category Management</h1>
                <Card className="p-4 shadow-md rounded-md">
                    <Form
                        form={form}
                        layout="inline"
                        onFinish={submitHandler}
                        className="flex flex-wrap gap-4"
                    >
                        <Form.Item
                            label="Category Title"
                            name="categoryTitle"
                            rules={[{ required: true, message: 'Please input the category title!' }]}
                        >
                            <Input placeholder="Enter category title" />
                        </Form.Item>

                        {/* <Form.Item
                            label="Image URL"
                            name="categoryImage"
                        >
                            <Input placeholder="Enter category image URL" />
                        </Form.Item> */}

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={isLoading}
                            >
                                {isLoading ? 'Creating...' : 'Create'}
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
                <Card>
                    <h2 className="text-center mt-4">Category List</h2>
                    {/* Category list will be displayed here */}
                    <Table
                        columns={columns}
                        dataSource={CategoryData}
                        loading={isLoading}
                        pagination={{ pageSize: 5 }}
                        scroll={{ x: "max-content" }}
                    />
                </Card>

            </div>
        </div>
    );
}

export default IndexCategory;